import dynamic from 'next/dynamic'
import { Flex, Stack, Text } from '@chakra-ui/react'
import { type Review } from '@common/hooks/useReviews'
import moment from 'moment'
import React, { Fragment } from 'react'
import ReviewMedia from './review-media'
import { StarIconPropsType } from '@icons/star-icon'

const StarIcon = dynamic<StarIconPropsType>(
  () => import('@icons/star-icon').then((mod) => mod.StarIcon),
  {
    ssr: false
  }
)

interface ReviewDetailProps extends Review {
  disableHeader?: boolean
}

const ReviewDetail: React.FC<ReviewDetailProps> = ({
  stars,
  medias,
  content,
  created_at,
  name,
  variant,
  disableHeader
}) => {
  return (
    <Stack>
      {!disableHeader && (
        <Stack direction="row" alignItems="center">
          <Text
            fontSize="lg"
            fontWeight={600}
            textTransform="capitalize"
            fontFamily="ITC"
          >
            {name}
          </Text>
          <Text
            fontSize="md"
            fontStyle="italic"
            color="gray.500"
            fontFamily="DM Sans"
          >
            Variant: {variant}
          </Text>
        </Stack>
      )}
      <Flex alignItems="center" gap={2}>
        {[...Array(stars)].map((_, index) => (
          <Fragment key={index}>
            <StarIcon width={15} height={15} full={true} />
          </Fragment>
        ))}
        {[...Array(5 - stars)].map((_, index) => (
          <Fragment key={index}>
            <StarIcon width={15} height={15} />
          </Fragment>
        ))}
        <Flex gap={1}>
          <Text color="gray.500" fontFamily="DM Sans">
            Reviewed on
          </Text>
          <Text fontWeight={500} fontFamily="DM Sans">
            {moment(created_at || '').format('D MMMM YYYY')}
          </Text>
        </Flex>
      </Flex>
      <Text fontFamily="DM Sans">{content}</Text>
      <Stack direction="row">
        {Array.isArray(medias) &&
          medias.map((media) => <ReviewMedia key={media.id} media={media} />)}
      </Stack>
    </Stack>
  )
}

export default ReviewDetail
